export default "__VITE_ASSET__BTLOtneZ__"